<template>
  <div>
    <el-form ref="formRef" :model="specialForm" label-width="180px">
      <el-form-item label="专区图片：">
        <img :src="src" alt="" v-if="src" @click="headImgUpdate" class="cursor" style="width: 80px;height: 80px;margin: 0">
        <div class="add" @click="headImgUpdate" v-else>
          <span>+</span>
        </div>
        <input type="file" accept=".jp2,.jpe,.jpeg,.jpg,.png"  @change="headImgChanged" ref="headImg" multiple="multiple" style="display:none;">
      </el-form-item>
      <el-form-item label="专区名字：">
        <el-input v-model="specialForm.name" placeholder="20个字以内" style="width:24em;"/>
      </el-form-item>
      <el-form-item label="专区描述：">
        <el-input type="textarea" v-model="specialForm.pdesc" placeholder="请填写专区描述" style="width:24em;"/>
      </el-form-item>
      <el-form-item label="排序：">
        <el-input v-model="specialForm.orderNum" placeholder="排序，越大越靠前" style="width:24em;"/>
      </el-form-item>
      <el-form-item label="性别：">
        <el-select v-model="sex" placeholder="Select" style="width: 24em">
          <el-option v-for="item in sexArray" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="是否需要职业认证：">
        <el-switch
            v-model="specialForm.jobShow"
            active-text="是"
            inactive-text="否">
        </el-switch>
      </el-form-item>
      <el-form-item label="是否需要学历认证：">
        <el-switch
            v-model="specialForm.eduShow"
            active-text="是"
            inactive-text="否">
        </el-switch>
      </el-form-item>
    </el-form>
    <div class="dialog-footer" style="text-align: center">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit" v-loading="loading">确定</el-button>
    </div>
  </div>

</template>

<script>
import { imgPostFormData } from "@/api/api"
import { addOrUpdateSpecials } from "@/api/url";

export default {
  name: "GiftManageDialog",
  props: {
    value: Object
  },
  data() {
    return {
      specialForm: this.value.specialForm,
      idx: this.value.ids,
      loading: false,

      files: null,
      src: this.value.ids > -1?this.value.specialForm.img:'',

      sexArray: [
        {label: '男', value: 1},
        {label: '女', value: 2},
      ],
      sex: this.value.specialForm.sex?this.value.specialForm.sex:1,

    }
  },
  methods: {
    cancel() {
      this.$emit("close");
    },

    //更改或添加
    headImgUpdate() {
      this.$refs.headImg.click();
    },

    //选取图片
    headImgChanged(e) {
      if(e.target.files[0]) {
        this.files = e.target.files[0];
        var windowURL = window.URL || window.webkitURL;
        this.src = windowURL.createObjectURL(this.files);
      }
    },

    summit() {
      if(!this.src) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '专区图片不能为空',
          type: 'warning'
        });
        return false
      }
      if(!this.specialForm.name) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '专区名字不能为空',
          type: 'warning'
        });
        return false
      }
      if(!this.specialForm.pdesc) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '专区描述不能为空',
          type: 'warning'
        });
        return false
      }
      if(!this.specialForm.orderNum) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '排序不能为空',
          type: 'warning'
        });
        return false
      }
      this.loading = true
      let param = new FormData();
      if (this.idx > -1) {
        param.append('id', this.specialForm.id);
      } else {
        param.append('id', '0');
      }
      param.append('name', this.specialForm.name);
      param.append('pdesc', this.specialForm.pdesc);
      param.append('sex', this.sex);
      param.append('orderNum', this.specialForm.orderNum);
      param.append('jobShow', this.specialForm.jobShow?true:false);
      param.append('eduShow', this.specialForm.eduShow?true:false);
      param.append('file', this.files);
      imgPostFormData(addOrUpdateSpecials, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm')
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
        this.loading = false
      }).catch(()=>{
        this.loading = false
      })
    }
  },
  mounted() {
  }
}
</script>

<style scoped>
.add {
  width: 80px;
  height: 80px;
  text-align: center;
  line-height: 80px;
  border: 1px dashed #ececec;
  font-size: 30px;
  cursor: pointer;
  float: left;
}
</style>
